import { useQuery } from "react-query";
import { fetchTermsConditionsContent } from "./api";

export function useTermsConditionsContent(filters, options={}) {
    return useQuery(["fetchTermsConditionsContent", filters], () => fetchTermsConditionsContent(), {
      staleTime: 60000 * 60, 
      ...options
    })
  }